// 0 处理中 1 完成 -1 失效或失败
export const statusMap = {
  '0': {
    label: '处理中',
    tagColor: 'processing',
  },
  '1': {
    label: '完成',
    tagColor: 'success',
  },
  '-1': {
    label: '失效或失败',
    tagColor: 'error',
  },
} as const
